var map = {
	"./Byju's2.jpg": 148,
	"./Logo 2.png": 149,
	"./c3.jpg": 150,
	"./cakesoft.png": 151,
	"./codechef.jpg": 152,
	"./ieee1.png": 153,
	"./ims2.jpg": 154,
	"./kaggle.png": 155,
	"./sum.png": 156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 147;